import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'peer-relationship',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './peer-relationship.component.html',
  styleUrl: './peer-relationship.component.css'
})
export class PeerRelationshipComponent implements OnInit {

  @Input() parentInterviewData: any;
  @Output() onSaveSection5 = new EventEmitter<any>();

  yesNo = EYesNo;
  peerRelationshipForm: FormGroup = new FormGroup([]);
  
  questionList = [
    {
      question: "Who are your child's friends? *",
      formControlName: "child_friends",
    },
    {
      question: "How much is your child influenced by peers? *",
      formControlName: "peer_influence",
    }
  ];
  radioQuestions = [
    {
      id: 'bully_report',
      questionText: "Has your child reported being teased, intimidated, rejected or bullied? *",
      formControlName: 'bully_report',
      infoFormControlName: 'bully_report_information'
    },
    {
      id: 'choice_friends',
      questionText: "Are you unpleased with your child's choice of friends? *",
      formControlName: 'choice_friends',
      infoFormControlName: 'choice_friends_information'
    },
    {
      id: 'examples',
      questionText: "Are there examples of your child doing something to please peers that caused him/her to be in trouble? *",
      formControlName: 'examples',
      infoFormControlName: 'examples_information'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}
  
  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['parentInterviewData'] && this.parentInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      const defaultValue = this.parentInterviewData && this.parentInterviewData[question.formControlName] !== undefined
                           ? this.parentInterviewData[question.formControlName]
                           : this.yesNo.No;

      group[question.formControlName] = new FormControl(
          String(defaultValue),
          Validators.required
      );
      group[question.infoFormControlName] = new FormControl({ value: this.parentInterviewData?.[question.infoFormControlName] || '', disabled: this.parentInterviewData?.[question.infoFormControlName] ? false : true });
    });
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.parentInterviewData?.[question.formControlName] || '', Validators.required);
    });

    this.peerRelationshipForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.peerRelationshipForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.peerRelationshipForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }          
        });
      }
    });
  }

  savePeerRelationship(): void {
    if (this.peerRelationshipForm.valid) {
      this.onSaveSection5.emit(this.peerRelationshipForm.value);
    }
  }


}
